import { render, staticRenderFns } from "./adCateForm.vue?vue&type=template&id=3386c2b8"
import script from "./adCateForm.vue?vue&type=script&lang=js"
export * from "./adCateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3386c2b8')) {
      api.createRecord('3386c2b8', component.options)
    } else {
      api.reload('3386c2b8', component.options)
    }
    module.hot.accept("./adCateForm.vue?vue&type=template&id=3386c2b8", function () {
      api.rerender('3386c2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/adCateForm.vue"
export default component.exports